import React from 'react'
import classnames from 'classnames'

const ColumnContent = (props) => {
  const content = props.content.map((col, idx) => {
    const text = col.items.map((item, idx) => (
      <span key={idx}>{item}</span>
    ))

    const title = !col.title ? false : (
      <h4>{col.title}</h4>
    )

    return (
      <div key={idx} className={classnames({
        'col-xs-12': props.content.length === 1,
        'col-xs-6 col-lg-4': props.content.length === 3,
        'col-xs-6': props.content.length >= 4
      })}>
        { title }
        <p>{text}</p>
      </div>
    )
  })

  return <div className='row'>{ content }</div>
}

export default ColumnContent



// WEBPACK FOOTER //
// ./src/components/Page/Content/Text/ColumnContent/index.js